import { Cells } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

const getCellByAlias = (cells: Cells, alias: string): ICell | undefined =>
  Object.values(cells).find(cell => cell.alias === alias);

export const getCellByCustomKey = (cells: Cells, customKey: string): ICell | undefined =>
  Object.values(cells).find(cell => cell.customKey === customKey);

export default getCellByAlias;
